import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';

export interface ActiveFilter {
  type: string;
  label: string;
  value: string | boolean | number;
  displayValue: string;
}

@Component({
  selector: 'app-filter-group',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, ClickOutsideDirective],
  templateUrl: './filter-group.component.html',
  styleUrl: './filter-group.component.scss',
})
export class FilterGroupComponent {
  @Input() hasActiveFilters = false;
  @Input() label = 'Filters';
  @Input() activeFilters: ActiveFilter[] = [];

  @Output() filterRemoved = new EventEmitter<ActiveFilter>();

  isOpen = false;

  toggleFilter(): void {
    this.isOpen = !this.isOpen;
  }

  closeFilter(): void {
    this.isOpen = false;
  }

  removeFilter(filter: ActiveFilter): void {
    this.filterRemoved.emit(filter);
  }
}
